<template>
    <div class="daBox">
        <!--搜索-->
        <div class="searchBox">
            <div class="left">{{type}}</div>
            <div class="right"><el-input v-model="searchValue" placeholder="请输入内容"></el-input><p  @click="goPolicy('搜索本站')" class="menuBox">搜索本站</p></div>
        </div>

        <!--页面内容-->
        <div  class="pageContent" v-if="!isShowError">
            <ul class="uls">
                <li class="lis" @click="goPolicyDetails(item)" v-for="(item,index) in dataList" :key="index">
                    <p></p>
                    <p v-html="item.title"></p>
                    <p v-html="item.createDate.slice(0,11)"></p>
                    <p v-if="item.files && item.files.length > 0">
                      <a style="color: chocolate;text-decoration-line:none" :href="url+'/api-file/files/downFileByfileId?client_id=webApp_hx&fileid='+item.files">
                        <span style="font-weight: bolder" class="el-icon-link">下载</span>
                      </a>
                    </p>
                </li>
            </ul>
        </div>
      <div v-if="isShowError">{{noContent}}</div>

    </div>
</template>

<script>
    export default {
        name: "policy",
        data(){
            return{
              searchValue:'',
              downloadFlag:false,
              dataList:[],
              type:'',
              url: this.$Config.base_server,
			  title:this.$route.query.title,
              noContent:'没有搜索到你输入的内容',
              isShowError:false,
			  client_id:localStorage.getItem("client_id")
            }
        },

        created(){
          this.isShowError = false
            if(this.title!='' && this.title.length>0){
              if (this.$route.query.title == "下载中心"){
                 this.downloadFlag = true
              }
              let q = {client_id: 'webApp_hx', type:this.title,status:'0'}
              if (this.$route.query.title == "搜索本站"){
                q.searchValue = this.$route.query.searchValue
              }
              this.getDataList(q);
            }
        },


        methods:{
          goPolicy(){
            let q = {client_id: this.client_id}
              if (this.searchValue && this.searchValue.length>0){
                q.searchValue = this.searchValue
              }else {
                  this.$message('请输入查询内容');
                return false
              }

          this.getDataList(q)
          },

            goPolicyDetails(item){
                if (this.downloadFlag){
                }else {
                  this.$router.push({path:'/policyDetails',query: {id:item.id}})
                }
            },


            // 请求列表数据
            getDataList(val){
              let _this = this;
              $.ajax({
                url: _this.url + "/api-base/oanotify/list/?client_id="+this.client_id,
                type: "GET",
                data:val,
                dataType: "json", //返回数据格式为json
                success: (res)=> {
                  if (res.data && res.data.length > 0){
                    _this.isShowError = false
                    _this.dataList = res.data
                  }else {
                    _this.isShowError = true
                  }
                },
                error: (err)=> {

                }
              });
            }
        }
    }
</script>

<style scoped lang="scss">
  .daBox{
        width: 100%;
        .searchBox{
            width: 100%;
            height: 60px;
            border-bottom: 2px solid #2e71c9;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .left{
                font-size: 14px;
            }
            .right{
                height: 100%;
                display: flex;
                align-items: center;
                .menuBox{
                    width: 120px;
                    height: 40px;
                    background: #2e71c9;
                    font-size: 14px;
                    color: #fff;
                    text-align: center;
                    line-height: 40px;
                }
            }
        }

        .pageContent{
            width: 100%;
            padding: 10px;
            box-sizing: border-box;
            .uls{
                width: 100%;
                .lis{
                    width: 100%;
                    height: 44px;
                    list-style: none;
                    border-bottom: 1px dashed #cecece;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    &:hover{
                        background: #2e71c9;
                        color: #fff;
                    }
                    p:nth-of-type(1){
                        width: 15px;
                        height: 15px;
                        background: url("../../../public/image/home/fagui.png");
                        background-size: 100% 100%;
                    }
                    p:nth-of-type(2){
                       font-size: 14px;
                        margin-left: 20px;
                    }
                    p:nth-of-type(3){
                        font-size: 14px;
                        margin-left: auto;
                    }
                    p:nth-of-type(4){
                        font-size: 14px;
                        color: #2e71c9;
                        margin-left: 15px;
                    }
                    &:hover p:nth-of-type(4){
                        background: #2e71c9;
                        color: #fff;
                    }
                }
            }
        }
    }
</style>
